module.exports = __webpack_public_path__ + "files/7f2175820f1281b0b14c03927cc36f05.png";